import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { ChevronRightMediumMIcon as Chevron } from '@alfalab/icons-glyph/ChevronRightMediumMIcon';
import { Link } from '@alfa-bank/site-link';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { LabelDesktop as Label } from '@alfa-bank/site-invest-mediaportal-common/components/label-desktop';
import { createPageUrl } from '@alfa-bank/site-invest-mediaportal-common/helpers';
import { FontStyrene } from '@alfa-bank/site-font-styrene';

import type { IOverviewArticleProps } from '../models';

import styles from './styles.css';

export const OverviewArticleDesktop: FC<IOverviewArticleProps> = ({
    analytics,
    article,
    articleLabelText,
    baseUrlToArticle,
}) => {
    if (!article) {
        return null;
    }

    const onClickReadCompletely = () => sendEvent(analytics?.clickReadCompletely);
    const pageUrl = createPageUrl(baseUrlToArticle, article.path);

    return (
        <Link
            dataTestId="overview-article"
            href={pageUrl}
            noUnderline
            onClick={onClickReadCompletely}
        >
            <Block
                className={cn(styles.external, styles.block)}
                notPadded
                styler={{ padding: 24, borderRadius: 24 }}
            >
                <Grid
                    className={cn(styles.external, styles.grid)}
                    collapse
                    flexDirection="column"
                    justify="between"
                >
                    <Label labelText={articleLabelText} />
                    <FontStyrene>
                        <Text
                            className={cn(styles.external, styles.text)}
                            kind="primaryInverted"
                            styler={{ margin: 0 }}
                            tag="span"
                            view="large"
                        >
                            <span
                                className={cn(styles.external, styles.wrappedText)}
                                title={article.title}
                            >
                                {article.title}
                            </span>
                            &nbsp;
                            <Chevron
                                className={cn(styles.external, styles.chevron)}
                                height={24}
                                width={24}
                            />
                        </Text>
                    </FontStyrene>
                </Grid>
            </Block>
        </Link>
    );
};
